var _effectorFileName = "/src/widgets/layouts/main/constants/array-divider.ts";
export type EqualParts<T> = T[][];
export const divideArrayIntoEqualParts = <T,>(arr: Array<T>, parts = 4): EqualParts<T> => {
  const numberOfParts = parts;
  const result: EqualParts<T> = [];
  if (arr.length < numberOfParts) {
    // If the array has fewer than 4 items, distribute them as evenly as possible into 4 parts
    for (let i = 0; i < numberOfParts; i++) {
      const part = arr.slice(i, i + 1);
      result.push(part.length > 0 ? part : []);
    }
  } else {
    // Normal case: calculate part sizes
    const partSize = Math.floor(arr.length / numberOfParts);
    const extraItems = arr.length % numberOfParts;
    let startIndex = 0;
    for (let i = 0; i < numberOfParts; i++) {
      const currentPartSize = partSize + (i < extraItems ? 1 : 0);
      const endIndex = startIndex + currentPartSize;
      result.push(arr.slice(startIndex, endIndex));
      startIndex = endIndex;
    }
  }
  return result;
};